import { useState } from "react";
import { useDataProvider, useNotify, useRefresh, useTranslate } from "ra-core";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

import type { CrmDataProvider } from "../providers/types";
import type { Lead } from "../types";

/** Antwort per WhatsApp. Geht über die Nodale-Funktion, nicht über die Tabelle. */
export const LeadSendMessage = ({ lead }: { lead: Lead }) => {
  const dataProvider = useDataProvider<CrmDataProvider>();
  const notify = useNotify();
  const refresh = useRefresh();
  const translate = useTranslate();
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);

  const send = async () => {
    if (!text.trim()) return;
    setLoading(true);
    try {
      await dataProvider.sendLeadMessage(lead.id, text.trim());
      setText("");
      notify(translate("resources.leads.notification.message_sent"), {
        type: "success",
      });
      refresh();
    } catch (error) {
      notify(error instanceof Error ? error.message : "Fehler", {
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <Textarea
        value={text}
        onChange={(event) => setText(event.target.value)}
        placeholder={translate("resources.leads.action.message_placeholder")}
        rows={3}
      />
      <div className="flex justify-end">
        <Button onClick={send} disabled={loading || !text.trim()} size="sm">
          {translate("resources.leads.action.send")}
        </Button>
      </div>
    </div>
  );
};
